import React, { FC } from 'react';
import { NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import { ChartComponent } from '../../../charts/ChartComponent';

export const ChartView: FC<NodeViewProps> = (props) => {
  const { config, width } = props.node.attrs;
  return (
    <NodeViewWrapper className="react-component">
      <ChartComponent width={width} config={config} />
    </NodeViewWrapper>
  );
};
